import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

const inp = "w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-vino-500 focus:ring-2 focus:ring-vino-500/20";

export default function Activar() {
  const { token } = useParams();
  const [info, setInfo] = useState(undefined);
  const [f, setF] = useState({ nueva: "", confirmar: "" });
  const [error, setError] = useState("");
  const [listo, setListo] = useState(null);
  useEffect(() => { api.get(`/auth/activacion/${token}`).then((r) => setInfo(r.data)).catch((e) => { setInfo(null); setError(formatApiErrorDetail(e.response?.data?.detail)); }); }, [token]);
  const enviar = async (e) => {
    e.preventDefault(); setError("");
    try { setListo((await api.post("/auth/activacion", { token, ...f })).data); } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-7 shadow-xl" data-testid="pagina-activar">
        <img src="/roge-cat.png" alt="Rogelio" className="mx-auto mb-3 h-20 w-auto" />
        {listo ? (
          <div className="text-center" data-testid="activacion-lista">
            <CheckCircle2 className="mx-auto h-10 w-10 text-emerald-600" />
            <p className="mt-2 font-display text-lg font-semibold">¡Tu cuenta está activa!</p>
            <p className="mt-1 text-sm text-slate-500">{listo.es_admin ? "Al ingresar, Rogelio te guiará para activar la verificación en dos pasos." : "Ya puedes ingresar con tu correo y tu nueva contraseña."}</p>
            <Link to="/login" className="mt-5 block rounded-lg bg-vino-700 py-2.5 text-sm font-semibold text-white" data-testid="activacion-ir-login">Ingresar a Roge</Link>
          </div>
        ) : info === undefined ? null : !info ? (
          <p className="text-center text-sm text-red-600" data-testid="activacion-error">{error}</p>
        ) : (
          <form onSubmit={enviar} className="space-y-3">
            <p className="text-center font-display text-lg font-semibold">¡Hola, {info.nombre}! Soy Rogelio 👋</p>
            <p className="text-center text-sm text-slate-500">Crea tu contraseña para {info.email} ({info.rol}). Mínimo 8 caracteres, con mayúscula, minúscula y número.</p>
            <input type="password" required value={f.nueva} onChange={(e) => setF({ ...f, nueva: e.target.value })} placeholder="Nueva contraseña" className={inp} data-testid="activar-nueva" />
            <input type="password" required value={f.confirmar} onChange={(e) => setF({ ...f, confirmar: e.target.value })} placeholder="Confirmar contraseña" className={inp} data-testid="activar-confirmar" />
            {error && <p className="text-sm text-red-600" data-testid="activar-error">{error}</p>}
            <button className="w-full rounded-lg bg-vino-700 py-2.5 text-sm font-semibold text-white hover:bg-vino-800" data-testid="activar-guardar">Crear contraseña</button>
          </form>
        )}
      </div>
    </div>
  );
}
